import React, { useEffect, useState } from 'react';
import * as libCon from '../community-hats-js-library/Constants';
import * as locCon from '../LocalConstants';
import {
  addNewPositionToATOSet,
  deletePositionToATOSet,
  getATObjectId,
  getATObjectStatus,
  getATOIdInsideSet,
  getATOInsideSetField,
  getStoredValue,
  RefATOInsideSetField,
  RefKeysOfATOSet,
  setATObjectInsideSet,
  setStoredValue,
} from '../hooks/StoreHooks';
import { RefContextLanguage } from '../providers/LanguageProvider';
import CustomText from '../elements/CustomText';
import { Popconfirm, Table } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import {
  SimpleCopyField,
  SimpleCopyFieldFromATOInsideSet,
  SimpleStoreCopyFieldFromATOInsideSet,
} from '../elements/SimpleStoreCopyField';
import { SyncATOInsideSetButton } from '../elements/SyncATOButton';
import CustomButton, { CustomPrimaryButtonWithDisability } from '../elements/CustomButton';
import {
  refreshSensor,
  RefReceivedSensorFiles,
  RefSensorStatus,
  getCurrentSensorSerials,
  isSensorPlacementActive,
} from '../hooks/BundleDeviceHooks';
import CustomSpin from '../elements/CustomSpin';
import { showErrorDialog, showErrorDialogByCode } from '../utils/dialogFunctions';
import { showNotification } from '../utils/generalFunctions';
import {
  formatDistanceShort,
  formatToStudyLocationReadable,
  nowInStudyLocation,
  timeNowInStudyLocation,
} from '../community-hats-js-library/utils/dateFunctions';
import { parseISO } from 'date-fns';
import { getDaysStyle, getEndDateStyle, getFrequencyStyle } from '../community-hats-js-library/utils/styleFunctions';
import CollectionStatus from '../elements/CollectionStatus';
import {
  filterObjectByKeys,
  isNullOrUndefined,
  isNullOrUndefinedOrEmpty,
  sleep,
  trim,
} from '../community-hats-js-library/utils/generalFunctions';
import CheckboxGroup from '../elements/CheckboxGroup';
import { ModalHook } from '../hooks/ModalHooks';
import { SimpleDatePickerFromId, SimpleTimePickerFromId } from '../elements/SimpleDatePicker';
import { logBatteryChange, removeSensorFromBundle } from '../community-hats-js-library/back-end/router';
import { PlacementPicture } from './ImageComponent';

export function SensorViewer({ positionId, positionNumber }) {
  const i18n = RefContextLanguage();

  const serial = RefATOInsideSetField(positionId, locCon.AT_OBJECT_SENSOR, libCon.ATF_SERIAL);

  const [isDuplicated, setIsDuplicated] = useState(false);

  const [deletingSensor, setDeletingSensor] = useState(false);

  useEffect(() => {
    let serials = getCurrentSensorSerials(true);

    // Filtes
    serials = filterObjectByKeys(
      serials,
      Object.keys(serials).filter((pos) => pos !== positionId)
    );

    setIsDuplicated(Object.values(serials).includes(serial));
  }, [serial, positionId]);

  const deleteLocalSensor = async () => {
    setDeletingSensor(true);

    // Check if sensor placement is active
    if (isSensorPlacementActive(positionId)) {
      // Can't delete
      showErrorDialog(i18n.t('placementActiveError'));
      setDeletingSensor(false);
      return;
    }

    let sensorId = getATOIdInsideSet(positionId, locCon.AT_OBJECT_SENSOR);

    // Checks Bundle Status to see if update is needed
    const bundleStatus = getATObjectStatus(locCon.AT_OBJECT_BUNDLE);
    const bundleId = getATObjectId(locCon.AT_OBJECT_BUNDLE);

    if (bundleStatus !== locCon.ATO_ONLY_LOCAL) {
      // Needs to update bundle in databse
      await removeSensorFromBundle(bundleId, sensorId);
    } else {
      await sleep(1500);
    }

    setDeletingSensor(false);
    showNotification(i18n.t('sensorRemovedSuccesfully'));

    // Deletes Sensor
    deletePositionToATOSet(positionId);
  };

  return (
    <div
      className="verticalSection"
      style={{ backgroundColor: 'var(--background-color-2)', marginTop: '1vh', marginBottom: '1vh', width: '95%' }}
    >
      <div className="horizontalSection">
        <div style={{ width: '90%', textAlign: 'center', marginTop: '2vh' }}>
          <CustomText type={locCon.ELEMENT_TITLE_TEXT} style={{ marginLeft: '15%' }}>
            {i18n.t('sensor') + ' ' + positionNumber}
          </CustomText>
        </div>
        <div style={{ width: '5%', marginRight: '2vh', marginTop: '2vh', textAlign: 'right' }}>
          {deletingSensor ? (
            <CustomSpin />
          ) : (
            <Popconfirm
              placement="top"
              title={i18n.t('deleteSensor')}
              description={i18n.t('removeSensorMessage')}
              okText={i18n.t('Yes')}
              cancelText={i18n.t('No')}
              onConfirm={() => deleteLocalSensor()}
            >
              <DeleteFilled style={{ color: 'var(--primary-color-2)', fontSize: 25 }} />
            </Popconfirm>
          )}
        </div>
      </div>

      <CheckboxGroup
        disableClick={true}
        mainCheckbox={{
          [libCon.ID]: locCon.getASCheckBoxId(positionId),
          [libCon.TEXT]: i18n.t('addSensorToBundle'),
          [libCon.CONTAINER]: (
            <div>
              <SimpleStoreCopyFieldFromATOInsideSet
                title={i18n.t('serial')}
                atoId={locCon.AT_OBJECT_SENSOR}
                positionId={positionId}
                fieldId={libCon.ATF_SERIAL}
                cleanBeforeSavingFunction={trim}
              />
              <SyncATOInsideSetButton
                positionId={positionId}
                atoId={locCon.AT_OBJECT_SENSOR}
                atoBehavior={libCon.ATO_BEHAVIOR_PULL}
                onClickCleanup={(val) => setStoredValue(locCon.getASCheckBoxId(positionId), val)}
                forceDisable={isDuplicated}
                forceDisabledText={i18n.t('sensorAlreadyexists')}
              />

              <div className="horizontalSection">
                <SimpleCopyFieldFromATOInsideSet
                  title={i18n.t('brand')}
                  atoId={locCon.AT_OBJECT_SENSOR}
                  positionId={positionId}
                  fieldId={libCon.ATF_BRAND}
                  enableCopy={false}
                />
                <SimpleCopyFieldFromATOInsideSet
                  title={i18n.t('model')}
                  atoId={locCon.AT_OBJECT_SENSOR}
                  positionId={positionId}
                  fieldId={libCon.ATF_MODEL}
                  enableCopy={false}
                />
              </div>
            </div>
          ),
        }}
      />
    </div>
  );
}

function SensorStatusViewer({ positionId, positionNumber }) {
  const i18n = RefContextLanguage();

  const receivedFiles = RefReceivedSensorFiles(positionId);
  const serial = RefATOInsideSetField(positionId, locCon.AT_OBJECT_SENSOR, libCon.ATF_SERIAL);
  const model = RefATOInsideSetField(positionId, locCon.AT_OBJECT_SENSOR, libCon.ATF_MODEL);
  const mac = RefATOInsideSetField(positionId, locCon.AT_OBJECT_SENSOR, libCon.ATF_BLUETOOTH_MAC);

  const placementPhotos = RefATOInsideSetField(
    positionId,
    locCon.AT_OBJECT_SENSORS_HOUSE_PLACEMENT,
    libCon.ATF_PLACEMENT_PHOTO
  );

  const lastBatteryChange = RefATOInsideSetField(positionId, locCon.AT_OBJECT_SENSOR, libCon.ATF_LATEST_BATTERY_CHANGE);

  // Battery Modal
  const [modal, openModal] = ModalHook();

  const [status, message] = RefSensorStatus(positionId);

  const [isSynching, setisSynching] = useState(false);

  const [isLoggingBatteryChange, setIsLoggingBatteryChange] = useState(false);

  const logBatteryChangeDialog = () => {
    openModal(
      i18n.t('logBatteryChange'),
      <div className="verticalSection">
        <div className="verticalSection">
          <SimpleDatePickerFromId title={i18n.t('date')} valueID={locCon.BATTERY_CHANGE_DATE} />
          <SimpleTimePickerFromId title={i18n.t('time')} valueID={locCon.BATTERY_CHANGE_TIME} />
        </div>
      </div>,
      [
        {
          text: i18n.t('cancel'),
          onClick: () => false,
          type: locCon.MODULE_CANCEL_BUTTON,
        },
        {
          text: i18n.t('logChange'),
          onClick: () => logBatteryChangeLocal(),
          type: locCon.MODULE_REGULAR_BUTTON,
        },
      ]
    );
  };

  const logBatteryChangeLocal = async () => {
    setIsLoggingBatteryChange(true);

    let finalDate = getStoredValue(locCon.BATTERY_CHANGE_DATE);
    if (isNullOrUndefined(finalDate)) finalDate = nowInStudyLocation(false);

    let finalTime = getStoredValue(locCon.BATTERY_CHANGE_TIME);
    if (isNullOrUndefined(finalTime)) finalTime = timeNowInStudyLocation(false);

    let sensorSerial = getATOInsideSetField(positionId, locCon.AT_OBJECT_SENSOR, libCon.ATF_SERIAL);
    let sensorId = getATOIdInsideSet(positionId, locCon.AT_OBJECT_SENSOR);

    let [status, records] = await logBatteryChange(sensorId, sensorSerial, finalDate, finalTime);

    if (status !== libCon.OK) showErrorDialogByCode(status);
    else {
      let sensorId = Object.keys(records)[0];
      setATObjectInsideSet(positionId, locCon.AT_OBJECT_SENSOR, sensorId, records[sensorId]);
      showNotification(i18n.t('batteryLogged'));
    }

    setStoredValue(locCon.BATTERY_CHANGE_DATE, null);
    setStoredValue(locCon.BATTERY_CHANGE_TIME, null);
    setIsLoggingBatteryChange(false);
  };

  const refreshRecords = async () => {
    setisSynching(true);
    let response = await refreshSensor(positionId);

    if (response !== libCon.OK) showErrorDialogByCode(response);
    else showNotification(i18n.t('refreshComplete'));

    setisSynching(false);
  };

  const sensorFilesColumns = [
    {
      title: 'Uploaded',
      dataIndex: libCon.ATF_DATE_UPLOADED,
      key: libCon.ATF_DATE_UPLOADED,
      align: 'center',
      defaultSortOrder: 'descend',
      sorter: (a, b) => parseISO(a[libCon.ATF_DATE_UPLOADED]) - parseISO(b[libCon.ATF_DATE_UPLOADED]),
      render: (val, record) => (
        <p style={{ textAlign: 'center' }}>
          {formatToStudyLocationReadable(val, false, false)}
          <br /> ({formatDistanceShort(val)})
        </p>
      ),
    },
    {
      title: 'Start Date',
      dataIndex: libCon.ATF_START_DATE,
      key: libCon.ATF_START_DATE,
      align: 'center',
      render: (val, record) => (
        <p style={{ textAlign: 'center' }}>
          {formatToStudyLocationReadable(val, false, false)}
          <br /> ({formatDistanceShort(val)})
        </p>
      ),
    },
    {
      title: 'End Date',
      dataIndex: libCon.ATF_END_DATE,
      key: libCon.ATF_END_DATE,
      align: 'center',
      render: (val, record) => (
        <p style={{ textAlign: 'center', ...getEndDateStyle(val, record) }}>
          {formatToStudyLocationReadable(val, false, false)}
          <br /> ({formatDistanceShort(val)})
        </p>
      ),
    },
    {
      title: 'Freq.',
      dataIndex: libCon.ATF_FREQUENCY,
      key: libCon.ATF_FREQUENCY,
      align: 'center',
      render: (val, record) => (
        <p style={{ textAlign: 'center', ...getFrequencyStyle(val, record) }}>{isNullOrUndefined(val) ? '--' : val}</p>
      ),
    },
    {
      title: 'Days',
      dataIndex: libCon.ATF_SIZE_IN_DAYS,
      key: libCon.ATF_SIZE_IN_DAYS,
      align: 'center',
      render: (val, record) => <p style={{ textAlign: 'center', ...getDaysStyle(val, record) }}>{val}</p>,
    },
  ];

  return (
    <div
      className="verticalSection"
      style={{ backgroundColor: 'var(--background-color-2)', marginTop: '1vh', marginBottom: '1vh', width: '95%' }}
    >
      <CustomText type={locCon.ELEMENT_TITLE_TEXT} style={{ marginTop: '1vh' }}>
        {i18n.t('sensor') + ' ' + positionNumber}
      </CustomText>

      <CollectionStatus status={status} message={message} />

      <SimpleCopyFieldFromATOInsideSet
        title={i18n.t('serial')}
        atoId={locCon.AT_OBJECT_SENSOR}
        positionId={positionId}
        fieldId={libCon.ATF_SERIAL}
      />

      <GoveeNameViewer model={model} mac={mac} />

      <SimpleCopyFieldFromATOInsideSet
        title={i18n.t('position')}
        atoId={locCon.AT_OBJECT_SENSORS_HOUSE_PLACEMENT}
        positionId={positionId}
        fieldId={libCon.ATF_POSITION}
        enableCopy={false}
      />

      <PlacementPicture
        positionPlacementObject={
          isNullOrUndefinedOrEmpty(placementPhotos) ? {} : placementPhotos[placementPhotos.length - 1]
        }
      />

      <div className="horizontalSection">
        <div style={{ width: '50%' }}>
          <SimpleCopyFieldFromATOInsideSet
            title={i18n.t('brand')}
            atoId={locCon.AT_OBJECT_SENSOR}
            positionId={positionId}
            fieldId={libCon.ATF_BRAND}
            enableCopy={false}
          />
        </div>
        <div style={{ width: '50%' }}>
          <SimpleCopyFieldFromATOInsideSet
            title={i18n.t('model')}
            atoId={locCon.AT_OBJECT_SENSOR}
            positionId={positionId}
            fieldId={libCon.ATF_MODEL}
            enableCopy={false}
          />
        </div>
      </div>

      <div className="verticalSection">
        <SimpleCopyField
          title={i18n.t('latestBatteryChange')}
          value={
            isNullOrUndefined(lastBatteryChange) ? (
              i18n.t('never')
            ) : (
              <>
                {`${formatToStudyLocationReadable(lastBatteryChange, true, false)}`}
                <br />
                {`(${formatDistanceShort(lastBatteryChange)})`}
              </>
            )
          }
          enableCopy={false}
        />

        <div className="verticalSection" style={{ marginTop: '1vh', marginBottom: '1vh' }}>
          {isLoggingBatteryChange === true ? (
            <CustomSpin type={locCon.BUTTON_SPINNER} />
          ) : (
            <div style={{ minWidth: '50%' }}>
              <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => logBatteryChangeDialog()}>
                {i18n.t('logBatteryChange')}
              </CustomButton>
            </div>
          )}
        </div>
        {modal}
      </div>

      <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{i18n.t('latestFiles')}</CustomText>

      <div className="verticalSection" style={{ marginTop: '2vh' }}>
        {isSynching ? (
          <CustomSpin type={locCon.BUTTON_SPINNER} />
        ) : (
          <CustomPrimaryButtonWithDisability
            isDisabled={isNullOrUndefined(serial)}
            title={i18n.t('incompleteDeployment')}
            description={i18n.t('addSerial')}
            onClick={() => refreshRecords()}
          >
            {i18n.t('refresh')}
          </CustomPrimaryButtonWithDisability>
        )}
      </div>

      <div style={{ width: '100%', marginTop: '2vh' }}>
        {receivedFiles.length === 0 ? (
          <div className="verticalSection">
            <CustomText type={locCon.DANGER_TEXT}>{i18n.t('noFilesReceived')}</CustomText>
          </div>
        ) : (
          <Table
            rootClassName="sensorTable"
            dataSource={receivedFiles}
            columns={sensorFilesColumns}
            size="small"
            pagination={{ pageSize: 4 }}
          />
        )}
      </div>
    </div>
  );
}

export function SensorSetViewer() {
  const keys = RefKeysOfATOSet();

  const i18n = RefContextLanguage();
  return (
    <div className="verticalSection">
      <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => addNewPositionToATOSet()}>
        {i18n.t('addSensorToBundle')}
      </CustomButton>
      {keys.length === 0 ? (
        <CustomText type={locCon.DANGER_TEXT}>{i18n.t('pleaseAddSensors')}</CustomText>
      ) : (
        <div></div>
      )}
      {keys.map((k, i) => (
        <SensorViewer key={k} positionId={k} positionNumber={i + 1} />
      ))}
    </div>
  );
}

export function SensorStatusSetViewer({ filterKeys = null }) {
  const keys = RefKeysOfATOSet();

  return (
    <div className="verticalSection">
      {keys
        .filter((k) => isNullOrUndefinedOrEmpty(filterKeys) || filterKeys.includes(k))
        .map((k, i) => (
          <SensorStatusViewer key={k} positionId={k} positionNumber={i + 1} />
        ))}
    </div>
  );
}

export const GoveeNameViewer = ({ model, mac }) => {
  const i18n = RefContextLanguage();

  const lastDigitsMac = isNullOrUndefined(mac) ? null : mac.replace(/:/g, '').slice(-4);

  return (
    <div style={{ marginBottom: '4vh' }}>
      {!isNullOrUndefined(model) && !isNullOrUndefined(lastDigitsMac) ? (
        <CustomText type={locCon.ELEMENT_TEXT}>{`(${model}_${lastDigitsMac})`}</CustomText>
      ) : (
        <CustomText type={locCon.ELEMENT_TEXT}>{`(${i18n.t('nameInGoveeAppNotAvailable')})`}</CustomText>
      )}
    </div>
  );
};

export const GoveeNameViewerFromPositionId = ({ positionId }) => {
  const mac = RefATOInsideSetField(positionId, locCon.AT_OBJECT_SENSOR, libCon.ATF_BLUETOOTH_MAC);
  const model = RefATOInsideSetField(positionId, locCon.AT_OBJECT_SENSOR, libCon.ATF_MODEL);

  return <GoveeNameViewer model={model} mac={mac} />;
};
